import Active from './components/Active.vue'
import History from './components/History.vue'

export default {
  routes: [
    {
      path: '/',
      redirect: '/active'
    },
    {
      path: '/active',
      component: Active
    },
    {
      path: '/history',
      component: History
    }    
  ]
}


// WEBPACK FOOTER //
// ./src/router.config.js